import React,{Component} from 'react';

import {Pagination} from 'react-bootstrap';

import API from '../../services/API';

import Container from '../../components/Container';
import Heading from '../../components/Heading';

import MasterCronTable from './components/MasterCronTable';

class MasterCron extends Component {
    constructor() {
        super();


        this.state = {
            pagesTotal: 0,
            activePage: 1,
            rows: [],
            isLoading: false
        };


        this.handlePageSelect = this.handlePageSelect.bind(this);
    }

    componentDidMount() {
        this.loadCronNotifications();
    }

    componentDidUpdate(nextProps,prevState) {
        if(this.state.activePage !== prevState.activePage) {
            this.loadCronNotifications();
        }
    }

    loadCronNotifications() {
        const {activePage} = this.state;
        this.setState({
            isLoading: true
        });


        API.MasterCron.getPage(activePage).then(res => {
            this.setState({
                ...res,
                isLoading: false
            });
        });


    }

    handlePageSelect(activePage) {
        this.setState({activePage});
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Master Cron"/>
                <MasterCronTable notifications={this.state.rows}/>
                <Pagination
                    items={this.state.pagesTotal}
                    maxButtons={20}
                    onSelect={this.handlePageSelect}
                    activePage={this.state.activePage}
                />
            </Container>
        );
    }
}

export default MasterCron;


// WEBPACK FOOTER //
// ./src/scenes/MasterCron/index.js